import { useState } from "react";

export default function ServiceChangeRestock(props) {

  const [restockAmount, setRestockAmount] = useState(props.service.extraData[0] ?? 0.0);

  let content;
  if (props.service.description != '') {
    content = <div>
      <h4 className='ui header'>Beschreibung</h4>
      {props.service.description}
      <div className='ui divider'></div>
    </div>
  }
  let Euro = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
  });

  let Num = new Intl.NumberFormat('de-DE',{
    minimumFractionDigits: 2
  });

  let tubeRows = props.machine.missingCoins==undefined || props.machine.missingCoins.length==0 ? 
    <tr>
      <td>---</td>
      <td>---</td>
      <td>---</td>
      <td>---</td>
    </tr>
  : props.machine.missingCoins.map(tube => <tr>
      <td>{tube.tube}</td>
      <td>{Euro.format(tube.coin*0.01)}</td>
      <td>{tube.actual_amount}</td>
      <td>{tube.missing_amount}</td>
    </tr>);

  const updateRestockAmount = (amount) => {
    props.service.extraData = [amount];
    setRestockAmount(amount);
    props.updateExtraData([amount]);
  }

  return (
    <div>
      {content}
      {props.machine.missingCoinCount < 25 ? <div className="ui medium header"><i className="green check icon"></i> Tubenstand ist ok</div> : <div className="ui medium header"><i className="red exclamation icon"></i> Tuben müssen befüllt werden</div>}
      Folgende Münzen fehlen:<br />
      <table className="ui unstackable table">
        <thead>
          <tr>
            <th>Tube</th>
            <th>Münze</th>
            <th>Ist</th>
            <th>Fehlmenge</th>
          </tr></thead>
        <tbody>
          {tubeRows}
        </tbody>
      </table>
      <br />
      Wenn Sie die Tuben befüllt haben, geben Sie bitte den Gesamtwert der befüllten Münzen ein:
      <form className="ui large form">
        <div className="field">
          <div className="ui right labeled input">
            <input type="number" name="restockAmount" value={restockAmount} min="0.0" max="300.0" step="0.01" onChange={e => updateRestockAmount(e.target.value)} />
            <div className="ui basic label">EUR</div>
          </div>
        </div>
      </form>
      Haben Sie die Tuben befüllt?<br />
    </div>

  );
}